export const osmViewUrl = (lat: number, lng: number, zoom = 17): string =>
    `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`;

export const osmDirectionsUrl = (lat: number, lng: number): string =>
    `https://www.openstreetmap.org/directions?from=&to=${lat}%2C${lng}`;

export const geoUri = (lat: number, lng: number, label?: string): string => {
    const q = label ? `${lat},${lng}(${encodeURIComponent(label)})` : `${lat},${lng}`;
    return `geo:${lat},${lng}?q=${q}`;
};

const isTouchDevice = (): boolean =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: coarse)').matches;

export const openMapView = (lat: number, lng: number, label?: string): void => {
    if (typeof window === 'undefined') return;
    if (isTouchDevice()) {
        window.location.href = geoUri(lat, lng, label);
        return;
    }
    window.open(osmViewUrl(lat, lng), '_blank');
};

export const openMapDirections = (lat: number, lng: number, label?: string): void => {
    if (typeof window === 'undefined') return;
    if (isTouchDevice()) {
        window.location.href = geoUri(lat, lng, label);
        return;
    }
    window.open(osmDirectionsUrl(lat, lng), '_blank');
};
